
export const customEvents = {
    field: {
        validation: 'fjs.field:validation'
    },
    form: {
        destroy:    'fjs.form:destroy',
        init:       'fjs.form:init',
        submit:     'fjs.form:submit',
        validation: 'fjs.form:validation'
    },
    group: {
        validation: 'fjs.group:validation'
    }
}
